import React, { useEffect, useState } from 'react';

const FireworksOverlay = ({ show, onComplete }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (show) {
      // Create firework particles
      const newParticles = [];
      const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#9B59B6', '#3498DB', '#E74C3C', '#2ECC71'];
      
      // Create multiple firework bursts
      for (let burst = 0; burst < 5; burst++) {
        const centerX = 20 + Math.random() * 60; // percent
        const centerY = 20 + Math.random() * 40; // percent
        const burstDelay = burst * 400; // ms
        
        // Each burst has multiple particles
        for (let i = 0; i < 30; i++) {
          const angle = (i / 30) * Math.PI * 2;
          const velocity = 50 + Math.random() * 100;
          const color = colors[Math.floor(Math.random() * colors.length)];
          
          newParticles.push({
            id: `${burst}-${i}`,
            startX: centerX,
            startY: centerY,
            dx: Math.cos(angle) * velocity,
            dy: Math.sin(angle) * velocity,
            color,
            size: 3 + Math.random() * 4,
            delay: burstDelay,
            duration: 1500 + Math.random() * 500
          });
        }
      }
      
      setParticles(newParticles);
      
      // Auto-hide after animation
      const timer = setTimeout(() => {
        setParticles([]);
        if (onComplete) onComplete();
      }, 4000);
      
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show && particles.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden">
      {/* Celebration text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center animate-bounce">
          <div className="text-6xl mb-4">🎉</div>
          <h1 className="text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 animate-pulse">
            VIP MILESTONE!
          </h1>
          <p className="text-2xl text-white mt-4 font-medium">
            $500,000 Trading Volume Reached!
          </p>
          <p className="text-lg text-white/70 mt-2">
            Welcome to the Elite Club
          </p>
        </div>
      </div>
      
      {/* Firework particles */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute rounded-full"
          style={{
            left: `${particle.startX}%`,
            top: `${particle.startY}%`,
            width: particle.size,
            height: particle.size,
            backgroundColor: particle.color,
            boxShadow: `0 0 ${particle.size * 2}px ${particle.color}`,
            animation: `firework-particle ${particle.duration}ms ease-out ${particle.delay}ms forwards`
          }}
        />
      ))}
      
      {/* CSS animations */}
      <style>{`
        @keyframes firework-particle {
          0% {
            transform: translate(0, 0) scale(1);
            opacity: 1;
          }
          100% {
            transform: translate(var(--dx, 0), var(--dy, 0)) scale(0);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default FireworksOverlay;
